import { combineReducers } from 'redux';

import partyReducer from './partyReducer';
import cityGuideReducer from './cityGuideReducer';
import shopifyReducer from './shopifyReducer';
import userReducer from './userReducer';
import activitiesReducer from './activivitiesReducer';
import orderReducer from './ordersReducers';
import { itineraryTemplatesReducer } from './itineraryTemplates';

const rootReducer = combineReducers({
  parties: partyReducer,
  users: userReducer,
  activities: activitiesReducer,
  orders: orderReducer,
  shopify: shopifyReducer,
  cityGuides: cityGuideReducer,
  itineraryTemplates: itineraryTemplatesReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
